exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#share-card-title{color:#ffc000;font-weight:bold;font-size:20px}.share-list-item{background-color:#000;border:1px solid #989898;cursor:pointer}.share-list-item:hover{border:1px solid #ffc000}#custom-link-input{color:#989898;border:1px solid #989898;padding:2px}.social-share-img{width:2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/pages/ShareCardPage/styles.scss
// module id = 877
// module chunks = 0